// @generated by protoc-gen-es v2.10.2
// @generated from file lda/v1alpha1/genomicquery.proto (package lda, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file lda/v1alpha1/genomicquery.proto.
 */
export const file_lda_v1alpha1_genomicquery = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message lda.RangeFilter.
 * Use `create(RangeFilterSchema)` to create a new message.
 */
export const RangeFilterSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 0);

/**
 * Describes the enum lda.RangeFilter.Condition.
 */
export const RangeFilter_ConditionSchema = /*@__PURE__*/
  enumDesc(file_lda_v1alpha1_genomicquery, 0, 0);

/**
 * @generated from enum lda.RangeFilter.Condition
 */
export const RangeFilter_Condition = /*@__PURE__*/
  tsEnum(RangeFilter_ConditionSchema);

/**
 * Describes the message lda.GeneFilter.
 * Use `create(GeneFilterSchema)` to create a new message.
 */
export const GeneFilterSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 1);

/**
 * Describes the message lda.EqtlFilter.
 * Use `create(EqtlFilterSchema)` to create a new message.
 */
export const EqtlFilterSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 2);

/**
 * Describes the message lda.DbSnpFilter.
 * Use `create(DbSnpFilterSchema)` to create a new message.
 */
export const DbSnpFilterSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 3);

/**
 * Describes the message lda.ClinvarConditionFilter.
 * Use `create(ClinvarConditionFilterSchema)` to create a new message.
 */
export const ClinvarConditionFilterSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 4);

/**
 * Describes the message lda.ClinvarFilter.
 * Use `create(ClinvarFilterSchema)` to create a new message.
 */
export const ClinvarFilterSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 5);

/**
 * Describes the message lda.MondoFilter.
 * Use `create(MondoFilterSchema)` to create a new message.
 */
export const MondoFilterSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 6);

/**
 * Describes the message lda.VectorSearchRequest.
 * Use `create(VectorSearchRequestSchema)` to create a new message.
 */
export const VectorSearchRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 7);

/**
 * Describes the message lda.VectorMetadata.
 * Use `create(VectorMetadataSchema)` to create a new message.
 */
export const VectorMetadataSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 8);

/**
 * Describes the message lda.QueryVariantRange.
 * Use `create(QueryVariantRangeSchema)` to create a new message.
 */
export const QueryVariantRangeSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 9);

/**
 * Describes the message lda.DbSnpModifier.
 * Use `create(DbSnpModifierSchema)` to create a new message.
 */
export const DbSnpModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 10);

/**
 * Describes the message lda.MondoModifier.
 * Use `create(MondoModifierSchema)` to create a new message.
 */
export const MondoModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 11);

/**
 * Describes the message lda.ClinvarModifier.
 * Use `create(ClinvarModifierSchema)` to create a new message.
 */
export const ClinvarModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 12);

/**
 * Describes the message lda.AnnotationModifier.
 * Use `create(AnnotationModifierSchema)` to create a new message.
 */
export const AnnotationModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 13);

/**
 * Describes the message lda.ResponseModifier.
 * Use `create(ResponseModifierSchema)` to create a new message.
 */
export const ResponseModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 14);

/**
 * Describes the message lda.DbSnpVariantModifier.
 * Use `create(DbSnpVariantModifierSchema)` to create a new message.
 */
export const DbSnpVariantModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 15);

/**
 * Describes the message lda.MondoVariantModifier.
 * Use `create(MondoVariantModifierSchema)` to create a new message.
 */
export const MondoVariantModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 16);

/**
 * Describes the message lda.ClinvarVariantModifier.
 * Use `create(ClinvarVariantModifierSchema)` to create a new message.
 */
export const ClinvarVariantModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 17);

/**
 * Describes the message lda.AnnotationFeature.
 * Use `create(AnnotationFeatureSchema)` to create a new message.
 */
export const AnnotationFeatureSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 18);

/**
 * Describes the message lda.AnnotationVariantModifier.
 * Use `create(AnnotationVariantModifierSchema)` to create a new message.
 */
export const AnnotationVariantModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 19);

/**
 * Describes the message lda.VariantModifier.
 * Use `create(VariantModifierSchema)` to create a new message.
 */
export const VariantModifierSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 20);

/**
 * Describes the message lda.QueryVariant.
 * Use `create(QueryVariantSchema)` to create a new message.
 */
export const QueryVariantSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 21);

/**
 * Describes the enum lda.QueryVariant.Genotype.
 */
export const QueryVariant_GenotypeSchema = /*@__PURE__*/
  enumDesc(file_lda_v1alpha1_genomicquery, 21, 0);

/**
 * @generated from enum lda.QueryVariant.Genotype
 */
export const QueryVariant_Genotype = /*@__PURE__*/
  tsEnum(QueryVariant_GenotypeSchema);

/**
 * Describes the message lda.QueryVariantRequest.
 * Use `create(QueryVariantRequestSchema)` to create a new message.
 */
export const QueryVariantRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 22);

/**
 * Describes the message lda.QueryVariantResponse.
 * Use `create(QueryVariantResponseSchema)` to create a new message.
 */
export const QueryVariantResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 23);

/**
 * Describes the message lda.ContextRegion.
 * Use `create(ContextRegionSchema)` to create a new message.
 */
export const ContextRegionSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 24);

/**
 * Describes the message lda.QueryMetrics.
 * Use `create(QueryMetricsSchema)` to create a new message.
 */
export const QueryMetricsSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 25);

/**
 * Describes the message lda.IsSampleAvailableRequest.
 * Use `create(IsSampleAvailableRequestSchema)` to create a new message.
 */
export const IsSampleAvailableRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 26);

/**
 * Describes the message lda.IsSampleAvailableResponse.
 * Use `create(IsSampleAvailableResponseSchema)` to create a new message.
 */
export const IsSampleAvailableResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_genomicquery, 27);

/**
 * @generated from service lda.GenomicQueryService
 */
export const GenomicQueryService = /*@__PURE__*/
  serviceDesc(file_lda_v1alpha1_genomicquery, 0);

